export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9 0C4.04 0 0 4.04 0 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7zM8 7.5V14h2V7.5H8zm2.25-2.25a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "18",
    "height": "18",
    "viewBox": "0 0 18 18",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};